import { AxiosInstance } from 'axios';
import { Dictionary } from 'vuex';

export enum Statuses {
  ERROR = 'error',
  READY = 'ready',
  WAITING = 'waiting',
}

export interface Contacts extends Dictionary<any> {
  address?: string;
  email?: string;
  phone?: string;
}

export interface Geo {
  latitude: number | null;
  longitude: number | null;
}

export interface Filial {
  name: string;
  contacts: Contacts;
  coords?: Geo;
}

export interface Municipality {
  id: Id;
  name: string;
  sort: any;
}

export interface Organization extends Filial {
  description: string;
  filials?: Filials;
  id: Id;
  logo: string;
  municipalityId: Id;
  photos: Photos;
  teachers: Array<Teacher>;
}

export interface Teacher {
  id: string | number;
  photo: string;
  fio: string;
  age: string | number;
  progress: string;
  groups: Array<Group>;
}

export interface Group {
  id: string | number;
  name: string;
}

export interface OrganizationExtended extends Organization {
  municipality?: Municipality;
}

export interface Params {
  id: string | number;
}

export interface Providers {
  $api: AxiosInstance;
  $config: Dictionary<any>;
}

export interface RootState {
  municipalities: Array<Municipality>;
}

export interface State {
  organization: Organization;
  programs: Programs;
  status: Statuses;
}

export type Id = string;
export type Filials = Array<Filial>;
export type Photos = Array<string>;
export type Program = any;
export type Programs = Array<Program>;
export type Teachers = Array<Teacher>;



// WEBPACK FOOTER //
// ./src/pages/organizations/card/types.ts